<template>
   <svg name="alert" viewBox="0 0 51 46" aria-hidden="true" focusable="false">
      <path
         d="M28.0981 2.25C26.9434 0.25 24.0566 0.25 22.9019 2.25L0.601772 40.875C-0.552922 42.875 0.890437 45.375 3.19982 45.375H47.8002C50.1096 45.375 51.5529 42.875 50.3982 40.875L28.0981 2.25ZM28.0312 18.8269C28.0312 20.2248 26.898 21.3581 25.5 21.3581C24.102 21.3581 22.9687 20.2248 22.9687 18.8269C22.9687 17.4289 24.102 16.2956 25.5 16.2956C26.898 16.2956 28.0312 17.4289 28.0312 18.8269ZM28.0312 24.8682V38.25H22.9687V24.8682H28.0312Z"
      />
   </svg>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped></style>
